import { useCallback, useEffect, useRef } from 'react';

/** Shared guard: hydrate initialArgs once per initialToolId (reset when id changes). */
const useApplyInitialArgsOnce = (initialToolId) => {
  const appliedInitialArgsRef = useRef(false);

  useEffect(() => {
    appliedInitialArgsRef.current = false;
  }, [initialToolId]);

  const resetAppliedInitialArgs = useCallback(() => {
    appliedInitialArgsRef.current = false;
  }, []);

  return { appliedInitialArgsRef, resetAppliedInitialArgs };
};

export default useApplyInitialArgsOnce;
